























import AbpBase from '@/lib/abpbase'
import Util from '@/lib/util'
import { Component } from 'vue-property-decorator'
import PageRequest from '@/store/entities/page-request'
import Link from '@/store/entities/link'
import { EventBus } from '@/lib/eventbus';
@Component
export default class Modules extends AbpBase {
    pagerequest:PageRequest=new PageRequest();
     collapseVal:string="2";
    link:Link = new Link();
    add(moduleName:string,name:string){
        this.link.target = "";
        this.link.external = false;
        this.link.url = '/'+moduleName
        this.link.name = name;
        this.create();
    }
    isFeatureEnabled(featureName :string){
        return Util.abp.features.isEnabled(featureName);
    }
    async create(){
        await this.$store.dispatch({
            type:'links/create',
            data:this.link
        }).then( () =>{
            this.link = new Link();
            EventBus.$emit('createMenuLink');
            this.getpage();
        });
    }
    getpage(){

    }
    async created(){
    }
    rules= {
        name: [
            { required: true, message: this.L('PleasefillName'), trigger: 'blur' }
        ],
        url: [
            { required: true, message: this.L('PleasefillUrl'), trigger: 'blur' }
        ]
    }
};
